import {LOGIN_FAILURE, LOGIN_SUCCESS, UPDATE_REFRESH_TOKEN} from './types'
import * as types from "../types";
import {clearPersistedAuth, loadPersistedAuth, savePersistedAuth} from 'helpers/authPersist'

// ─── Guest state mặc định ────────────────────────────────────────────────────
// Dùng khi không có persist hoặc persist không hợp lệ.
// Rõ ràng hơn {} — tránh component đọc auth.user bị crash.
const GUEST_STATE = {
  login: false,
  user: null,
  token: null,
  success: false,
  failure: false,
};

// ─── Khởi động: đọc lại từ localStorage ngay lập tức ─────────────────────────
// Nếu có dữ liệu persist → app render ngay mà không cần đợi API /me
// API /me vẫn được gọi ngầm (qua saga) để refresh data mới nhất
const INITIAL_STATE = loadPersistedAuth() || GUEST_STATE;

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOGIN_SUCCESS: {
      savePersistedAuth(action.payload);
      return action.payload;
    }

    case LOGIN_FAILURE: {
      // Không xóa persist — có thể là network lỗi tạm thời
      // Chỉ xóa khi LOGOUT thực sự
      return {
        ...state,
        failure: true,
      };
    }

    case UPDATE_REFRESH_TOKEN: {
      // Guard: không update nếu token mới là null/rác (network lỗi)
      const newToken = action.token;
      const isInvalidToken = !newToken ||
          newToken === 'null' ||
          newToken === 'undefined' ||
          newToken === '';

      if (isInvalidToken) {
        // Giữ nguyên state hiện tại — không ghi đè bằng token hỏng
        return state;
      }

      const next = {
        ...state,
        token: newToken,
        success: true,
        failure: false,
      };
      savePersistedAuth(next);
      return next;
    }

    case types.LOGOUT: {
      clearPersistedAuth();
      return GUEST_STATE; // Trả về guest state thay vì null
    }

    case types.CHECK_AUTHENTICATE_FAIL: {
      // Chỉ xóa persist nếu lỗi thật sự (ví dụ: 401 Unauthorized),
      // không xóa nếu chỉ là network timeout.
      // action.networkError = true khi saga detect là lỗi mạng.
      // if (!action.networkError) {
      //   clearPersistedAuth();
      // }
      const { type, networkError, ...rest } = action;
      return {
        ...GUEST_STATE,
        ...rest,
      };
    }

    default:
      return state;
  }
}